import React from 'react'
import ConsentGate from './ConsentGate'

interface CalendarProps {
    mode?: 'WEEK' | 'MONTH' | 'AGENDA'
    height?: string
    width?: string
    calendarId: string
}

const Calendar = ({ mode, height, width, calendarId }: CalendarProps) => {
    return (
        <ConsentGate
            type="google"
            serviceName="Google Calendar"
            controllerName="Google"
            description="Google Calendar uses cookies to display calendar events, track viewing behavior, and may collect analytics data. Google may use this information for personalization and advertising across their services."
        >
            <iframe
                src={`https://calendar.google.com/calendar/embed?height=${height || 600}&wkst=1&ctz=Europe%2FLondon&showPrint=0&mode=${mode || 'AGENDA'}&src=${calendarId}&color=%23f5be5f`}
                style={{borderWidth: 0}}
                width={width || "100%"}
                height={height || "600"}
                frameBorder="0"
                scrolling="no"
                className="border-0 rounded-lg shadow-lg my-4"
            ></iframe>
        </ConsentGate>
    )
}

export default Calendar